import React from 'react';

export default function Divider(props) {
  const { classNames } = props;
  return <div className={`w-full ${classNames}`}></div>;
}
